/* @ts-ignore */
import * as React from 'react';
import { Form, Input, AutoComplete, Select } from 'antd';
import { Button } from '@ui/components';
import { transformFormatSource } from '@ui/tools/transformSource';

import './createManagerForm.less';

const { Item } = Form;

export default Form.create({
  name: 'form_in_modal',
  onValuesChange: (props: any, changedValues: any) => props.onChangeValues(changedValues),
})(
  // @ts-ignore
  class extends React.Component {
    render() {
      const {
        // @ts-ignore
        onCreate,
        // @ts-ignore
        form: { getFieldDecorator },
        // @ts-ignore
        regions,
        // @ts-ignore
        countries,
        // @ts-ignore
        hasCountry,
      } = this.props;

      const regionsSource = transformFormatSource(regions);
      const countriesSource = transformFormatSource(countries);

      return (
        <Form className="create-manager-form">
          <div className="create-manager-form__body">
            <Item
              label="IdLotus"
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-end',
              }}
            >
              {getFieldDecorator('idLotus')(<Input size="large" className="input-id-lotus" />)}
            </Item>

            <Item label="Логин">
              {getFieldDecorator('login', {
                rules: [{ required: true, message: 'вы должны заполнить поле' }],
              })(<Input size="large" />)}
            </Item>

            <Item label="Пароль">
              {getFieldDecorator('password', {
                rules: [{ required: true, message: 'вы должны заполнить поле' }],
              })(<Input size="large" />)}
            </Item>

            <Item>
              <Item label="Имя" style={{ display: 'inline-block', width: 'calc(50% - 12px)' }}>
                {getFieldDecorator('firstName')(<Input size="large" />)}
              </Item>

              <Item
                label="Отчество"
                style={{
                  display: 'inline-block',
                  width: 'calc(50% - 12px)',
                  marginLeft: '24px',
                }}
              >
                {getFieldDecorator('middleName')(<Input size="large" />)}
              </Item>
            </Item>

            <Item label="Фамилия">{getFieldDecorator('lastName')(<Input size="large" />)}</Item>

            <Item label="Страна">
              {getFieldDecorator('country', {
                rules: [{ required: true, message: 'вы должны заполнить поле' }],
              })(
                <AutoComplete dataSource={countriesSource} size="large">
                  <Input />
                </AutoComplete>,
              )}
            </Item>

            {hasCountry && (
              <Item label="Области">
                {getFieldDecorator('regions', {
                  rules: [{ required: true, message: 'вы должны заполнить поле' }],
                })(
                  <Select mode="multiple" size="large">
                    {regionsSource.map((d: any) => (
                      <Select.Option key={d.value}>{d.text}</Select.Option>
                    ))}
                  </Select>,
                )}
              </Item>
            )}
          </div>

          <Item style={{ paddingTop: '16px' }}>
            <Item style={{ padding: '16px' }}>
              <Button onClick={onCreate} htmlType="submit" className="button-create-store">
                Сохранить
              </Button>
            </Item>
          </Item>
        </Form>
      );
    }
  },
);



// WEBPACK FOOTER //
// ./src/scenes/Managers/components/CreateManagerForm/CreateManagerForm.tsx